






















































import { QuestionUpload } from '@/resource/question-upload/question-upload.model';
import { User } from '@/resource/user/user.model';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class UploadQuestionContainer extends Vue {
  @Prop({ required: true })
  uploadQuestions!: QuestionUpload[];

  @Prop({ default: false })
  noAction!: boolean;

  data: any[] = [];

  header = this.noAction
    ? [
        'Id',
        'Subject',
        'Chapter',
        'Form',
        'Question Type',
        'Difficulty',
        'Private',
        'status',
        'File',
        'Requested By',
        'Requested At',
        'Collection',
      ]
    : [
        'Id',
        'Subject',
        'Chapter',
        'Form',
        'Question Type',
        'Difficulty',
        'Private',
        'status',
        'File',
        'Requested By',
        'Requested At',
        'Action',
      ];

  getData() {
    if (!this.uploadQuestions || !this.uploadQuestions.length) return [];
    this.data = this.uploadQuestions.map(question => {
      return {
        id: question.id,
        subject: question.subject,
        chapter: question.chapter,
        form: question.form,
        questionType: question.questionType,
        difficulty: question.difficulty,
        isPrivate: question.isPrivate,
        status: question.status,
        file: question.fileUpload.s3Location,
        requestedBy: this.getName(question.collection.user),
        requestedAt: this.$dayjs(question.createdAt).format('h:mma, DD/M/YYYY'),
        collection: `/collections/${question.collection.uuid}`,
        link: `/upload-question/${question.id}`,
      };
    });
  }

  created() {
    this.getData();
  }

  getName(user: User) {
    if (user) {
      const name = `${user.firstName} ${user.lastName}`;

      return this.noAction ? `${name} - ${user.email}` : name;
    } else {
      return 'N/A';
    }
  }
}
